module.exports = __webpack_public_path__ + "img/group2.c018e9b2.png";